export default "__VITE_ASSET__4f900070__"